import DialogCreateType from "@components/Dialog/Create";
import type { ISettingsCrudSelection } from "./useSettingsCrudPage";

export interface ISettingsNameDialogsState {
  createNewModal: boolean;
  setCreateNewModal: (value: boolean) => void;
  editModal: boolean;
  setEditModal: (value: boolean) => void;
  showDuplicateAlert: boolean;
  setShowDuplicateAlert: (value: boolean) => void;
  duplicateAlertMessage: string;
  optionSelected?: ISettingsCrudSelection;
  handleSaveNewOption: (value: string, selectCategory?: string, selectType?: string) => void;
  handleEditOption: (value: string, selectCategory?: string, selectType?: string) => void;
}

interface Props {
  crud: ISettingsNameDialogsState;
  newTitle: string;
  editTitle: string;
  newPlaceholder: string;
  editPlaceholder: string;
  resetDuplicateAlert?: boolean;
}

const SettingsNameDialogs = ({
  crud,
  newTitle,
  editTitle,
  newPlaceholder,
  editPlaceholder,
  resetDuplicateAlert = false,
}: Props) => (
  <>
    <DialogCreateType
      title={newTitle}
      show={crud.createNewModal}
      placeholder={newPlaceholder}
      onClose={() => {
        crud.setCreateNewModal(false);
        if (resetDuplicateAlert) {
          crud.setShowDuplicateAlert(false);
        }
      }}
      onSave={(value) => crud.handleSaveNewOption(value)}
      showDuplicateAlert={crud.showDuplicateAlert}
      duplicateAlertMessage={crud.duplicateAlertMessage}
      onInputChange={resetDuplicateAlert ? () => crud.setShowDuplicateAlert(false) : undefined}
    />

    <DialogCreateType
      title={editTitle}
      show={crud.editModal}
      placeholder={editPlaceholder}
      onClose={() => {
        crud.setEditModal(false);
      }}
      onSave={(value) => crud.handleEditOption(value)}
      editValue={crud.optionSelected?.name}
    />
  </>
);

export default SettingsNameDialogs;
